/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiSeoLocationByPathFaqsListParams } from './model/apiSeoLocationByPathFaqsListParams';
import type { LandingFAQ } from './model/landingFAQ';

/**
 * Returns fact interpolated FAQs for the SEO location at a page path.
 */
export const apiSeoLocationByPathFaqsList = (
  params: ApiSeoLocationByPathFaqsListParams,
  signal?: AbortSignal
) => {
  return HTTP<LandingFAQ[]>({ url: `/api/v7/seo-location/faqs/`, method: 'GET', params, signal });
};

export const getApiSeoLocationByPathFaqsListQueryKey = (
  params?: ApiSeoLocationByPathFaqsListParams
) => {
  return [`/api/v7/seo-location/faqs/`, ...(params ? [params] : [])] as const;
};

export const getApiSeoLocationByPathFaqsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSeoLocationByPathFaqsList>>,
  TError = ErrorType<unknown>
>(
  params: ApiSeoLocationByPathFaqsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSeoLocationByPathFaqsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSeoLocationByPathFaqsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSeoLocationByPathFaqsList>>> = ({
    signal,
  }) => apiSeoLocationByPathFaqsList(params, signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiSeoLocationByPathFaqsList>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiSeoLocationByPathFaqsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSeoLocationByPathFaqsList>>
>;
export type ApiSeoLocationByPathFaqsListQueryError = ErrorType<unknown>;

export function useApiSeoLocationByPathFaqsList<
  TData = Awaited<ReturnType<typeof apiSeoLocationByPathFaqsList>>,
  TError = ErrorType<unknown>
>(
  params: ApiSeoLocationByPathFaqsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSeoLocationByPathFaqsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiSeoLocationByPathFaqsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
